export default "<span #iconContainer class=\"Icon54\" aria-hidden=\"true\">\n</span>\n";